import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { UserContext } from "../../../amplify/authenticator-provider";
import { Container } from "../../../library/basicComponents";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission } from "../../../library/helpers";
import SelectSchedule from "../../../library/selectSchedule";
import useLang from "../../../hooks/useLang";
import { useFetchUsersWithExisting, USER_QUERIES } from "../../../hooks/useFetchUsers";

const ContainerWrap = styled(Container)`
  margin-top: 10px;
  .ant-modal-body {
    padding-top: 10px;
  }
  border: 0;
`;

const AddOwner = ({ setLeadOwner, setPrimaryOwner, lead, setOwnerIdsata, ownerIdsData }) => {
  const { user } = useContext(UserContext);
  const [selectedOwnerIds, setLeadOwnerIds] = useState([]);
  const [primaryOwnerId, setPrimaryOwnerId] = useState();
  const [lang] = useLang();

  // Extract existing users from lead (for deactivated users scenario)
  const existingUsers = (lead?.leadUsers || [])
    .filter(item => item?.user?.id)
    .map(item => item.user);

  // Uses setting flag (isActiveUserRendering) to determine active or all users
  // Automatically appends existing users if they're missing from fetched list
  const { users: fetchedUsers, loading: fetchLoading } = useFetchUsersWithExisting({
    existingUsers,
    skip: !user?.company?.id,
    fetchPolicy: "network-only",
    query: USER_QUERIES.ALL,
    isCurrentLocationUser: true,
    isAllLocationUsers: true,
  });

  // Transform users for dropdown format
  const users = (fetchedUsers || []).map(el => ({
    id: el.id,
    name: `${el.fullName || `${el.firstName || ""} ${el.lastName || ""}`.trim()} (${
      el?.companyRole?.name || "N/A"
    })`,
  }));

  useEffect(() => {
    if (lead?.leadUsers) {
      const ownerIds = (lead?.leadUsers || []).map(el => el?.user?.id);
      const primaryId = (lead?.leadUsers || []).length > 0 ? lead?.leadUsers[0]?.user?.id : "";
      setLeadOwnerIds(ownerIds);
      setPrimaryOwnerId(String(primaryId));
      if (setLeadOwner) {
        setLeadOwner(ownerIds);
        setPrimaryOwner(primaryId);
      }
    }
  }, [lead]);

  // Filter lead owners from users list based on selected IDs (handle type mismatch)
  const leadOwners = users.filter(el => selectedOwnerIds.some(id => String(id) === String(el.id)));
  const canEdit = checkAccessPermission(AccessPermissionAction.LEAD_OWNER_ADD_EDIT);

  useEffect(() => {
    setOwnerIdsata &&
      setOwnerIdsata({
        ...ownerIdsData,
        isOwnerIdsEmpty: selectedOwnerIds.length > 0,
        isPrimaryIdEmpty: !!primaryOwnerId,
      });
  }, [selectedOwnerIds, primaryOwnerId]);

  return (
    <ContainerWrap auto>
      <Row gutter={[4, 16]}>
        <Col xs={24} sm={24} md={16} xl={16} lg={16} id="antdOwnerDropdown">
          <label className="mb-[5px]">
            Owners<span className="requireFieldStar ml-[2px]">*</span>
          </label>
          <p>
            <SelectSchedule
              getPopupContainer={() => document.getElementById("antdOwnerDropdown")}
              mode="multiple"
              value={users.length > 0 ? selectedOwnerIds : undefined}
              placeholder={lang.selectOwnersLabel}
              showAll={false}
              onChange={e => {
                if (setLeadOwner) {
                  setLeadOwner(e);
                }
                setLeadOwnerIds(e);
              }}
              data={users}
              width="98%"
              size="large"
              loading={fetchLoading}
              isNeedToSearch
              disabled={!canEdit}
            />
          </p>
        </Col>
        <Col xs={24} sm={24} md={8} xl={8} lg={8} id="antdPrimaryOwnerDropdown">
          <label className="mb-[5px]">
            Primary Owner<span className="requireFieldStar ml-[2px]">*</span>
          </label>
          <SelectSchedule
            getPopupContainer={() => document.getElementById("antdPrimaryOwnerDropdown")}
            value={users.length > 0 ? primaryOwnerId : undefined}
            placeholder="Select primary owner"
            showAll={false}
            onChange={e => {
              setPrimaryOwner(e);
              setPrimaryOwnerId(e);
            }}
            data={leadOwners}
            width="100%"
            size="large"
            loading={fetchLoading}
          />
        </Col>
        {/* <Col
          xs={24}
          sm={24}
          md={8}
          xl={8}
          lg={8}
          style={{ textAlign: "right", paddingTop: 25 }}
        >
          <InlineFormButton
            type={"primary"}
            onClick={submitVehicle}
            loading={loading}
          >
            {editVehicle ? "Update" : "Add"}
          </InlineFormButton>
        </Col> */}
      </Row>
      {/* </FormCntr> */}
      {/* <FormCntr></FormCntr>
      <ContactListTable
        vehiclesList={vehicles}
        onDeleteVehicle={removeVehicle}
        onEditVehicle={handleEdit}
      /> */}
    </ContainerWrap>
  );
};
export default AddOwner;
